export default __webpack_public_path__ + "static/media/donati.f0e03eb4.svg";